
import { defineComponent } from 'vue';
import { IMockMessage } from '@/types/interfaces';
import AppSmallLoader from '@/components/UI/AppSmallLoader.vue';
import { MOCK_MESSAGE_STATUS } from '@/types/enums';

export default defineComponent({
  components: {
    AppSmallLoader,
  },
  props: {
    msg: { type: Object as () => IMockMessage, required: true },
  },
  emits: ['resend'],
  setup(props, { emit }) {
    function resendMessage() {
      if (props.msg.status === MOCK_MESSAGE_STATUS.ERROR) {
        emit('resend', props.msg);
      }
    }

    return {
      resendMessage,
      MOCK_MESSAGE_STATUS,
    };
  },
});
